export const SET_STEPS = "SET_STEPS";
export const INCREMENT_CURRENT_STEP = "INCREMENT_CURRENT_STEP";
export const DECREMENT_CURRENT_STEP = "DECREMENT_CURRENT_STEP";
export const RESET_STEP = "RESET_STEP";
